export type ExportStatus = 'COMPLETED' | 'IN_PROGRESS' | 'AWAITING';

export enum DumpListSort {
  DATE_DESC = 'DATE_DESC',
  DATE_ASC = 'DATE_ASC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
}

export interface ExportFolder {
  id: string;
  name: string;
  createdAt: string;
  exportStatus: ExportStatus;
}

export interface TriggerPayload {
  period: string;
}

export interface KeyPayload {
  key: string;
}

export type DumpFilterFormValues = {
  search: string;
};
